import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { MDCMenu } from '@material/menu';
import 'next/stylesheets/components/projects/todo-quick-filter';

Component('tr-project-todo-quick-filter', {
  mixins: [eventListenerMixin],

  properties: {
    filterUrl: {
      type: String,
    },
    filterCategory: {
      type: String,
    },
  },

  connected() {
    this.menu = new MDCMenu(this.querySelector('.mdc-menu'));
    this.listenTo(this.menu, 'MDCMenu:selected', this.handleSelected.bind(this));

    const that = this;
    // eslint-disable-next-line no-underscore-dangle
    const advanceIndex = this.menu.list_.listElements
      .findIndex(it => it.dataset.key === 'advance');

    // eslint-disable-next-line no-underscore-dangle
    this.menu.list_.foundation_.handleClick = function handleClick(index) {
      if (index === advanceIndex) {
        that.namespacedTrigger('advanceSelected', { bubbles: true });
        return;
      }

      this.constructor.prototype.handleClick.call(this, index);
    };
  },

  handleSelected(event) {
    let { key, value } = event.detail.item.dataset;

    if (!key || key === 'advance') {
      return;
    }

    let predicate = 'eq';

    if (key === 'assignee_id') {
      value = ['', value];
      predicate = 'in';
    } else if (key === 'overdue') {
      key = 'due_at';
      value = 'this_day';
      predicate = 'lt';
    }

    const data = {
      projects_filter: {
        category: this.filterCategory,
        conditions_attributes: {
          0: {
            key,
            predicate,
            conjunction: 'con_and',
            form_value: value,
          },
        },
      },
    };

    $.post(this.filterUrl, data, () => {}, 'script');
  },

  disconnected() {
    this.stopListening();
  },
});
